import { createSlice } from "@reduxjs/toolkit";

interface ClientCanvas {
  canvasWidth: number;
  canvasHeight: number;
  canvasHeightFull: number;
  canvasTop: number;
  canvasLeft: number;
}

type viewType = "Front" | "Back" | "Left" | "Right" | "Neck";

interface DesignerState {
  view: viewType[];
  activeView: viewType;
  mobileDrawer: boolean;
  selectedLayer: any;
  zoom: number;
  NewImageFormulaFront: number;
  NewImageFormulaBack: number;
  NewImageFormulaLeft: number;
  NewImageFormulaRight: number;
  NewImageFormulaNeck: number;
  frontDesigns: any[];
  backDesigns: any[];
  leftDesigns: any[];
  rightDesigns: any[];
  neckDesigns: any[];
  frontClientCanvas: ClientCanvas;
  backClientCanvas: ClientCanvas;
  leftClientCanvas: ClientCanvas;
  rightClientCanvas: ClientCanvas;
  neckClientCanvas: ClientCanvas;
  saveImageArtloading: boolean;
  approveImageArtloading: boolean;
  downloadloading: boolean;
}

const defaultCanvas: ClientCanvas = {
  canvasWidth: 0,
  canvasHeight: 0,
  canvasHeightFull: 0,
  canvasTop: 0,
  canvasLeft: 0,
};

const initialState: DesignerState = {
  view: [],
  activeView: "Front",
  mobileDrawer: false,
  selectedLayer: null,
  zoom: 1,
  NewImageFormulaFront: 1,
  NewImageFormulaBack: 1,
  NewImageFormulaLeft: 1,
  NewImageFormulaRight: 1,
  NewImageFormulaNeck: 1,
  frontDesigns: [],
  backDesigns: [],
  leftDesigns: [],
  rightDesigns: [],
  neckDesigns: [],
  frontClientCanvas: { ...defaultCanvas },
  backClientCanvas: { ...defaultCanvas },
  leftClientCanvas: { ...defaultCanvas },
  rightClientCanvas: { ...defaultCanvas },
  neckClientCanvas: { ...defaultCanvas },
  saveImageArtloading: false,
  approveImageArtloading: false,
  downloadloading: false,
};

export const designerSlice = createSlice({
  name: "designer",
  initialState,
  reducers: {
    setView: (state, action) => {
      state.view = action.payload;
    },
    setActiveView: (state, action) => {
      state.activeView = action.payload;
    },
    setMobileDrawer: (state, action) => {
      state.mobileDrawer = action.payload;
    },
    setSelectedLayer: (state, action) => {
      state.selectedLayer = action.payload;
    },
    setZoom: (state, action) => {
      state.zoom = action.payload;
    },
    setNewImageFormula: (state, action) => {
      switch (state.activeView) {
        case "Front":
          state.NewImageFormulaFront = action.payload;
          break;
        case "Back":
          state.NewImageFormulaBack = action.payload;
          break;
        case "Left":
          state.NewImageFormulaLeft = action.payload;
          break;
        case "Right":
          state.NewImageFormulaRight = action.payload;
          break;
        case "Neck":
          state.NewImageFormulaNeck = action.payload;
          break;
        default:
          break;
      }
    },
    setDesigns: (state, action) => {
      switch (state.activeView) {
        case "Front":
          state.frontDesigns = action.payload;
          break;
        case "Back":
          state.backDesigns = action.payload;
          break;
        case "Left":
          state.leftDesigns = action.payload;
          break;
        case "Right":
          state.rightDesigns = action.payload;
          break;
        case "Neck":
          state.neckDesigns = action.payload;
          break;
        default:
          break;
      }
    },
    setCurrentDesignsView: (state, action) => {
      state.selectedLayer = action.payload;
      switch (state.activeView) {
        case "Front":
          state.frontDesigns = [...state.frontDesigns, action.payload];
          break;
        case "Back":
          state.backDesigns = [...state.backDesigns, action.payload];
          break;
        case "Left":
          state.leftDesigns = [...state.leftDesigns, action.payload];
          break;
        case "Right":
          state.rightDesigns = [...state.rightDesigns, action.payload];
          break;
        case "Neck":
          state.neckDesigns = [...state.neckDesigns, action.payload];
          break;
        default:
          break;
      }
    },
    updateCurrentDesignsView: (state, action) => {
      switch (state.activeView) {
        case "Front":
          state.frontDesigns = action.payload;
          break;
        case "Back":
          state.backDesigns = action.payload;
          break;
        case "Left":
          state.leftDesigns = action.payload;
          break;
        case "Right":
          state.rightDesigns = action.payload;
          break;
        case "Neck":
          state.neckDesigns = action.payload;
          break;
        default:
          break;
      }
    },
    setClientCanvas: (state, action) => {
      switch (state.activeView) {
        case "Front":
          state.frontClientCanvas = action.payload;
          break;
        case "Back":
          state.backClientCanvas = action.payload;
          break;
        case "Left":
          state.leftClientCanvas = action.payload;
          break;
        case "Right":
          state.rightClientCanvas = action.payload;
          break;
        case "Neck":
          state.neckClientCanvas = action.payload;
          break;
        default:
          break;
      }
    },
    removeDesign: (state, action) => {
      state.selectedLayer = null;
      switch (state.activeView) {
        case "Front":
          state.frontDesigns = state.frontDesigns.filter(
            (item: any) => item.id !== action.payload,
          );
          break;
        case "Back":
          state.backDesigns = state.backDesigns.filter(
            (item: any) => item.id !== action.payload,
          );
          break;
        case "Left":
          state.leftDesigns = state.leftDesigns.filter(
            (item: any) => item.id !== action.payload,
          );
          break;
        case "Right":
          state.rightDesigns = state.rightDesigns.filter(
            (item: any) => item.id !== action.payload,
          );
          break;
        case "Neck":
          state.neckDesigns = state.neckDesigns.filter(
            (item: any) => item.id !== action.payload,
          );
          break;
        default:
          break;
      }
    },
    setSaveImageArtloading: (state, action) => {
      state.saveImageArtloading = action.payload;
    },
    setApproveImageArtloading: (state, action) => {
      state.approveImageArtloading = action.payload;
    },
    setDownloadloading: (state, action) => {
      state.approveImageArtloading = action.payload;
    },
  },
});

export const {
  setView,
  setActiveView,
  setMobileDrawer,
  setSelectedLayer,
  setZoom,
  setCurrentDesignsView,
  removeDesign,
  updateCurrentDesignsView,
  setDesigns,
  setClientCanvas,
  setNewImageFormula,
  setSaveImageArtloading,
  setApproveImageArtloading,
  setDownloadloading,
} = designerSlice.actions;

export default designerSlice.reducer;
